import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RolesEnum } from 'src/app/core/enums/RolesEnum';
import { UserContextService } from 'src/app/core/services/user-context.service';

export enum AiGenerationOption {
  All = 'all',
  OnlyWithoutAi = 'onlyWithoutAi',
  Cancel = 'cancel'
}

@Component({
  selector: 'pd-ai-generation-options-modal',
  templateUrl: './ai-generation-options-modal.component.html',
  styleUrls: ['./ai-generation-options-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AiGenerationOptionsModalComponent {
  public dialogRef = inject<MatDialogRef<AiGenerationOptionsModalComponent>>(MatDialogRef);
  private readonly userContextService = inject(UserContextService);

  public AiGenerationOption = AiGenerationOption;
  public selectedOption: AiGenerationOption = AiGenerationOption.OnlyWithoutAi;

  public get canRegenerateAllAvatars(): boolean {
    const currentUser = this.userContextService.user.value;
    if (!currentUser) {
      return false;
    }

    return currentUser.role_id === RolesEnum.MasterLead || currentUser.isAvatarEditor;
  }

  public confirm(): void {
    this.dialogRef.close(this.selectedOption);
  }

  public cancel(): void {
    this.dialogRef.close(AiGenerationOption.Cancel);
  }
}
